import React, { useState } from "react";
import "./QualityPolicy.css";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Certification_Modal from "../../../../../../common/common_modal/certification_modal/Certification_Modal";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faUpload,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";

function Quality_Policy() {
  const [showModal, setShowModal] = useState(false);
  const [showFileSection, setShowFileSection] = useState(false);

  const handleUploadClick = () => {
    setShowFileSection(true);
  };

  const handleDeleteClick = () => {
    setShowFileSection(false);
  };

  return (
    <>
      <section className="Imperiality Quality_Policy">
        <div className="back_div">
          <Common_Back_Btn backText="Quality Policy" />
        </div>

        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              Our company is committed to maintaining the highest standards of
              accuracy, reliability, and integrity in all laboratory operations.
              We ensure continuous improvement of our processes, compliance with
              quality standards, and customer satisfaction through effective
              documentation and controlled file management — including secure
              addition and deletion of files as per QMS guidelines.
            </p>
          </div>

          {/* File Section */}
          {showFileSection && (
            <div className="file_section">
              <div className="row">
                <div className="col-md-4">
                  <Form.Group className="form_group file_field">
                    <div className="image_holder">
                      <img
                        className="img_preview"
                        src="/assets/images/other/dummy-image.png"
                        alt="preview"
                      />
                    </div>

                    <div className="span_text_holder">
                      <div>
                        <span>Quality Policy 1001.PDF</span>
                      </div>

                      <div>
                        <span
                          className="green_text"
                          onClick={() => setShowModal(true)}
                        >
                          <FontAwesomeIcon icon={faEye} className="me-2" />
                          View
                        </span>
                      </div>
                    </div>
                  </Form.Group>
                </div>
              </div>
            </div>
          )}

          {/* Upload / Delete Button */}
          <div className="permission_btn_holder">
            {!showFileSection ? (
              <Button
                className="upload_btn"
                onClick={handleUploadClick}
              >
                <FontAwesomeIcon icon={faUpload} className="me-2" />
                Upload File
              </Button>
            ) : (
              <Button
                className="upload_btn"
                onClick={handleDeleteClick}
              >
                <FontAwesomeIcon icon={faTrashCan} className="me-2" />
                Delete File
              </Button>
            )}
          </div>
        </div>
      </section>

      {/* View Modal */}
      <Certification_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        modalHeadingText="View Quality Policy"
        imgSrc="/assets/images/cerificate/certi.png"
        btnText="Download"
      />
    </>
  );
}

export default Quality_Policy;
